<h3><i class="bhi-sms"></i>{{ title }}</h3>
<span [innerHTML]="message"></span>
<input [(ngModel)]="hotname" placeholder="Enter Tearsheet Name">
<section class="modal-footer footer-btns">
  <button type="button" theme="nav" class="danger" (click)="decline()">
    {{ btnCancelText }}
  </button>
  <button type="button" theme="nav" (click)="accept()">
      {{ btnOkText }}
  </button>
</section>
